import { cr, URLS } from "fire-wind-water";
import { $cmsData } from "../common/setting";
import { settings } from "../common/setting";
import { user } from "../user";
import { customFormService } from "../services/customForm";
import { $renderComponent } from "../render";
import { FieldBind } from "../field/field";
import { $hfsDatePicker } from "../../datepicker";
import { updateDirty, clearValue } from "../common/field";
import { arts } from "../render/arts";
import * as $ from "jquery";
const inputSearchArt = require("../../art/common/inputSearch.art");

class Form {
  $skelem = ".sk-component.CUSTOMFORM";
  $fieldbind: any[] = [];
  static $$fields: { [label: string]: any } = {};

  isButtonShow = false;
  disabled = false;
  isSelected = false;
  timer = null;
  field;
  skAfterViewChecked(): void {
    if (!settings.customFormId) {
      let formId: number | string = "";
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (d.type === "CUSTOMFORM") {
            formId = d.historyContent.content.customFormId;
          }
        });
      });
      settings.customFormId = formId;
    }
    this.getForm();
    $(document).on(
      "click.ent-select .select-mask",
      ".ent-select .select-mask",
      () => {
        if (
          this.field &&
          this.field.fieldInfo.submitBusiness == 1 &&
          !this.isSelected
        ) {
          //必选
          this.field.setValue("");
          this.skUpdateView();
        }
      }
    );
  }

  getForm(): boolean {
    const info: any = {
      tenantId: settings.tenantId,
      customFormId: settings.customFormId,
      globalUserId: user.globalUserId,
    };
    if (cr.isArray(info.customFormId)) {
      info.customFormId = info.customFormId[0];
    }
    if (!info.customFormId) {
      return false;
    }
    // console.log(info);
    customFormService.getCustomForm(info).subscribe((res) => {
      if (res.result === 0) {
        res.content.customFormId = info.customFormId;
        this.initForm(res.content);
      }
    });
  }

  initForm(res): void {
    const items: any[] = [];
    cr.each(res.items, (d) => {
      let item: any = null;
      switch (d.fieldType) {
        case "TEXT":
          item = new $sk.Text(d);
          break;
        case "LIST":
          if (d.fieldExtraType == "10") {
            item = new $sk.CustomPolicy(d);
          } else {
            item = this.createLIST(d);
          }
          break;
        case "FILE":
          item = new $sk.File(d);
          break;
        case "DATETIME":
          item = new $sk.DateTime(d);
          break;
        case "LINE":
          item = new $sk.Line(d);
          break;
        case "DESC":
          item = new $sk.Desc(d);
          break;
        case "POLICY":
          item = new $sk.Policy(d);
          break;
      }
      if (item) {
        Form.$$fields[item.fieldName] = item;
        items.push(item);
      }
    });
    this.updateComponents(items);
  }

  createLIST(d): any {
    switch (parseInt(d.displayType, 10)) {
      case 5:
      case 6:
        return new $sk.Checkbox(d);
      case 4:
        return new $sk.Select(d);
      default:
        return new $sk.List(d);
    }
  }

  updateComponents(res): void {
    this.isButtonShow = res && res.length > 0;
    cr.each($cmsData.container, (item: { [label: string]: any }) => {
      cr.each(item, (d) => {
        if (
          d.type === "CUSTOMFORM" &&
          settings.customFormId == d.historyContent.content.customFormId
        ) {
          d.historyContent.content.items = res;
          d.historyContent.type = d.type;
          $renderComponent(d.historyContent, d.category);
          this.skUpdateView();
        }
      });
    });
    if (!settings.isPreview) {
      let fid = settings.customFormId;
      if (cr.isArray(fid)) {
        fid = fid[0];
      }
      const html: string = arts.FIELD({ items: res });
      const customFormList: HTMLElement = document.querySelector(
        `.customform-${fid}`
      );
      const customFormButton: HTMLElement = document.querySelector(
        `.custom-button-${fid}`
      );
      if (html) {
        customFormList.innerHTML = html;
      }
      customFormList.style.display = "block";
      customFormButton.style.display = this.isButtonShow ? "block" : "none";
      // console.log(customFormList, customFormButton);
      this.skUpdateView();
    }
  }

  skUpdateView(): void {
    const elems = document.querySelectorAll("[sk-field]");
    this.$fieldbind = [];
    cr.each(elems, (d) => {
      const t = d.getAttribute("sk-field");
      this.$fieldbind.push(new FieldBind(d, Form.$$fields[t], this));
    });
    // console.log(res);
  }

  textChange(e, t): void {
    Form.$$fields[t].setValue(e.target.value);
  }
  inputChange(e, t): void {
    Form.$$fields[t].setValue(e.target.value);
    const field = Form.$$fields[t];
    this.field = field;
    field.otherValue = "";
    field.thirdValue = 0;
    if (t === "enterprise" && field.fieldInfo.openBusiness === 1) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getBusinessList(e.target.value, t);
      }, 800);
    }
  }
  getBusinessList(value, t) {
    const field = Form.$$fields[t];
    this.isSelected = false;
    if (value.length < 1) {
      return;
    }
    customFormService
      .serchBusiness({
        tenantId: settings.tenantId,
        objMark: $sk.template.get().common.objMark,
        objId: $sk.template.get().common.objId,
        keyword: value,
      })
      .subscribe((res) => {
        if (res.result == 0) {
          if (value.length > 1) {
            field.listOptions = res.content.items;
            const businessList = res.content.items.map((item) => {
              item.showName = item.name.replace(
                new RegExp(value, "gi"),
                `<span class="high-light">${value}</span>`
              );
              return item;
            });
            const params = {
              listOptions: businessList,
              fieldName: t,
            };
            const dom = document.getElementById("ent-select-main-wrap");
            dom.innerHTML = inputSearchArt(params);
            // 控制下拉项显隐
            if ($(".c-form-select.ent-select").hasClass("open")) {
              $(".c-form-select.ent-select").removeClass("open");
            } else {
              $(".c-form-select.ent-select").addClass("open");
            }
            this.skUpdateView();
          }
        } else {
          this.field.fieldInfo.submitBusiness = 0;
          this.field.fieldInfo.openBusiness = 0;
          Form.$$fields[t].setValue(value);
        }
      });
  }
  setCode(e, t) {
    Form.$$fields[t].setCode(e.target.value);
  }

  sendCode(e, s, k): void {
    Form.$$fields[s].sendCode(k, { tenantId: settings.tenantId });
  }

  changeListOtherValue(e, o, d): void {
    const field = Form.$$fields[d];
    field.setOtherValue(o, e.target.value);
  }

  changeList(e, v, d) {
    const field = Form.$$fields[d];
    const o = field.listOptions.filter((b) => {
      return b.optionId == v;
    })[0];
    field.setValue(o);
  }

  clickList(ev, v, d, i): void {
    const field = Form.$$fields[d];
    let o = field.listOptions.filter((b) => {
      return b.optionId == v;
    })[0];
    if (field.isCascade == 1) {
      o = field.listOptions[i].filter((b) => {
        return b.optionId == v;
      })[0];
      field.setManyValue(o);
    } else {
      field.setValue(o.optionId);
    }
  }

  clickListFocus(ev, o, d): void {
    ev.stopPropagation();
    const field = Form.$$fields[d];
    field.setValue(o);
  }

  changeCheckBox(e, v, d) {
    const field = Form.$$fields[d];
    const o = field.listOptions.filter((b) => {
      return b.optionId == v;
    })[0];
    field.setValue(o, e.target.checked);
  }

  changeTime(e, d, cn): void {
    const field = Form.$$fields[d];
    $hfsDatePicker(
      {
        elem: e.target,
        format: field.format,
        model: field.model,
      },
      (o) => {
        field.setValue(o.model);
        cn();
      }
    );
  }

  changeFile(e, d): void {
    Form.$$fields[d].upload(e.target.files[0]);
  }

  clearFile(e, d): void {
    Form.$$fields[d].setValue(null);
  }

  changePolicy(e, d): void {
    const field = Form.$$fields[d];
    field.setValue(e.target.checked);
  }

  customSave(): void {
    if (this.disabled) {
      return;
    }
    this.disabled = true;
    this.save();
  }

  save() {
    this.disabled = false;
    // 模糊匹配且只允许提交工商企业名称，没有选择企业时，公司字段值置为空
    const entField = Form.$$fields["enterprise"];
    if (
      entField &&
      entField.fieldInfo.openBusiness === 1 &&
      entField.fieldInfo.submitBusiness === 1 &&
      !this.isSelected
    ) {
      entField.setValue(null);
    }
    const result = updateDirty(Form.$$fields);
    this.updateView();
    const info: any = {
      customFormId: settings.customFormId,
      globalUserId: user.globalUserId,
      instanceId: settings.instanceId,
      items: result.field,
      linkId: "",
      openId: "",
      referenceUrl: "",
      signPointItems: [],
      tenantId: settings.tenantId,
      url: window.location.href,
      ver: "v2.0.1",
      channel_code: settings.channel_code,
      siteId: settings.siteId,
      memberId: user.memberId,
      sess: user.session,
    };
    if (result.verificationCode) {
      info.verificationCode = result.verificationCode;
    }
    if (result.scenesKey) {
      info.scenesKey = result.scenesKey;
    }
    if (cr.isArray(info.customFormId)) {
      info.customFormId = info.customFormId[0];
    }
    if (!result.isVerify) {
      return;
    }
    if (settings.isPreview && URLS.getURL("preview")) {
      $sk.alert("当前页面为预览页面，不能提交");
      return;
    }
    this.disabled = true;
    customFormService.action(info).subscribe((res) => {
      if (res.result == 0) {
        window.scroll(0, 0);
        clearValue(Form.$$fields);
        this.updateView();
        $sk.alert("提交成功");
      } else {
        $sk.alert(res.desc);
      }
      this.disabled = false;
    });
  }

  updateView() {
    cr.each(this.$fieldbind, (d) => {
      d.updateView();
    });
  }
  setBusiness(e, name, code, d) {
    this.isSelected = true;
    const field = Form.$$fields[d];
    field.setValue(name);
    field.otherValue = code;
    field.thirdValue = 1;
    this.skUpdateView();
  }
}

export { Form };
